import { toast } from 'react-hot-toast';
import { authAPI } from '../api/auth';
import { setUserData, updateUserData } from '../utils/functions';
import { actionWrapper } from './actionWrapper';

export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PART_USER_DATA = 'SET_PART_USER_DATA';

export const confirmEmail = (otp, callback, errorCallback) => actionWrapper(async () => {
  const confirmResult = await authAPI.confirmEmail(otp);
  callback?.();
  console.log('===confirmResult', confirmResult);
}, errorCallback);

const setUserStoreData = (userData) => {
  return {
    type: SET_USER_DATA,
    payload: userData,
  };
};

const loginProceed = (userData) => {
  setUserData(userData);
  return setUserStoreData(userData);
};

const logoutProceed = () => {
  return {
    type: SET_USER_DATA,
    payload: null,
  };
};

const updateProceed = (userData) => {
  updateUserData(userData);
  return setUserStoreData(userData);
};

export const login = (loginData, { setFieldError }, callback) => actionWrapper(async (dispatch) => {
  const authData = await authAPI.login(loginData);
  dispatch(loginProceed(authData));
  callback?.();
}, (errors) => {
  Object.keys(errors).forEach(field => {
    setFieldError(field, errors[field]);
  });
});


export const logout = () => () => {
  localStorage.removeItem('user');
  localStorage.removeItem('steps');
  window.location = '/';
  return logoutProceed();
};

export const register = (registerData, { setFieldError }, callback) => actionWrapper(async () => {
  registerData.is_web = 1;
  await authAPI.register(registerData);
  callback?.();
}, (errors) => {
  Object.keys(errors).forEach(field => {
    setFieldError(field, errors[field]);
  });
});

export const getUserData = () => actionWrapper(async (dispatch, getState) => {
  const oldUserData = getState().auth.userData;
  const userData = await authAPI.getUserData();
  const newUserData = {
    token: oldUserData.token,
    user: userData,
  };
  dispatch(updateProceed(newUserData));
});

export const getUserExisting = () => actionWrapper(async (dispatch) => {
  const userData = await authAPI.getUserData();
  if (!userData) {
    return dispatch(logoutProceed());
  }
});

export const deleteAccount = () => actionWrapper(async (dispatch) => {
  await authAPI.delete();
  dispatch(logout());
});

export const sendSupport = (supportData, callback) => actionWrapper(async () => {
  await authAPI.support(supportData);
  callback?.();
});

export const forgotPassword = (email, { setFieldError }, callback) => actionWrapper(async () => {
  await authAPI.forgot(email);
  callback?.();
}, () => {
  setFieldError('email', 'User with this email doesn\'t exist');
});

export const googleLogin = (authData, callback) => actionWrapper(async (dispatch) => {
  authData.is_web = 1;
  const userData = await authAPI.googleLogin(authData);
  callback?.();
  dispatch(loginProceed(userData));
}, () => {
  toast.error('Google login failed. Please try again.', {
    position: 'bottom-right',
    duration: 3000,
  });
});